"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generate = void 0;
const jspdf_1 = require("jspdf");
const jspdf_autotable_1 = __importDefault(require("jspdf-autotable"));
const moment_1 = __importDefault(require("moment/moment"));
const dayjs_1 = __importDefault(require("../shared/lib/dayjs"));
const currency_1 = require("../shared/utils/currency");
function generate(props) {
    const fontStyle = "";
    const docPdf = new jspdf_1.jsPDF({
        format: "letter",
    });
    let pageWidth = docPdf.internal.pageSize.getWidth();
    docPdf.text("Tabla de Amortización Banorte Finance", pageWidth / 2, 20, { align: "center" });
    docPdf.text("FECHA DE EMISIÓN: " + (0, moment_1.default)().format("DD/MM/YYYY"), pageWidth / 2, 30, {
        align: "center",
    });
    docPdf.text(props.model_name + " " + props.model_year, pageWidth / 2, 40, { align: "center" });
    docPdf.setFontSize(13);
    docPdf.text("Monto del Préstamo: " + (0, currency_1.parseToMexicanPeso)(props.montoDelPrestamo), 20, 60);
    docPdf.text("Enganche: " + (0, currency_1.parseToMexicanPeso)(props.enganche), 120, 60);
    docPdf.line(15, 65, 200, 65, "F");
    docPdf.text(`Plazo: ${props.plazo} meses`, 20, 75);
    docPdf.text("Comisión de Apertura (4): " + (0, currency_1.parseToMexicanPeso)(props.comisionDeApertura), 120, 75);
    docPdf.text("Pago Mensual (1): " + (0, currency_1.parseToMexicanPeso)(props.pagoMensual), 20, 85);
    docPdf.text("Seguro de Auto: " + props.seguroDeAuto, 120, 85);
    docPdf.text("Tasa de Interés (2): " + props.tasaDeInteres + "%", 20, 95);
    docPdf.text("Seguro de Vida: " + (0, currency_1.parseToMexicanPeso)(props.seguroDeVida), 120, 95);
    docPdf.text("CAT (3): " + Math.round(props.cat) + "%", 20, 105);
    docPdf.text("Monto Total a Pagar: " + (0, currency_1.parseToMexicanPeso)(props.montoTotalAPagar), 120, 105);
    docPdf.setFontSize(12);
    docPdf.text("1 Pago mensual sin IVA.", 20, 125);
    docPdf.text("2", 20, 130);
    docPdf.setFont(fontStyle, "bold");
    docPdf.text("Tasa Fija de Interés Anual.", 24, 130);
    docPdf.setFont(fontStyle, "normal");
    docPdf.text(`3`, 20, 135);
    docPdf.setFont(fontStyle, "bold");
    docPdf.text(`CAT ${Math.round(props.cat)}%`, 24, 135);
    docPdf.setFont(fontStyle, "normal");
    docPdf.text(`"Sin IVA" informativo.`, 48, 135);
    docPdf.setFont(fontStyle, "bold");
    docPdf.text(`Fecha de cálculo: `, 90, 135);
    docPdf.setFont(fontStyle, "normal");
    docPdf.text(`${(0, dayjs_1.default)().format("DD/MM/YYYY")}.`, 127, 135);
    docPdf.setFont(fontStyle, "bold");
    docPdf.text(`Vigencia de la oferta: `, 20, 140);
    docPdf.setFont(fontStyle, "normal");
    docPdf.text(`${(0, dayjs_1.default)().format("DD/MM/YYYY")}.`, 64, 140);
    docPdf.text("4 Comisión por apertura 0.00% sobre el monto a financiar (pago único al inicio).", 20, 145);
    docPdf.text("Aplican Restricciones.", 20, 150);
    docPdf.text("Las cantidades presentadas en esta tabla se encuentran en pesos méxicanos.", 20, 155);
    docPdf.text("La Tabla de Amortización no considera el seguro de daños, este deberá cotizarse y dependiendo de la forma de pago, podrá modificar los datos aquí asentados.", 20, 165, { align: "justify", maxWidth: 170 });
    docPdf.text("Este documento es para efectos informativos y no constituye obligación y ofrecimiento formal por parte de Banorte, en el otorgamiento del Crédito.", 20, 175, { align: "justify", maxWidth: 170 });
    docPdf.text("Las condiciones de los Créditos estarán sujetas a cambios sin previo aviso.", 20, 185, {
        align: "justify",
    });
    const tableRows = props.registros.map((i) => [
        i.numAmortizacion,
        (0, currency_1.parseToMexicanPeso)(Number(i.pagoAmortizacion)),
        (0, currency_1.parseToMexicanPeso)(Number(i.seguroDanos)),
        (0, currency_1.parseToMexicanPeso)(Number(i.seguroVida)),
        (0, currency_1.parseToMexicanPeso)(Number(i.abonoCapital)),
        (0, currency_1.parseToMexicanPeso)(Number(i.saldoCapital)),
        (0, currency_1.parseToMexicanPeso)(Number(i.interesAmortizacion)),
        (0, currency_1.parseToMexicanPeso)(Number(i.saldoFin)),
    ]);
    (0, jspdf_autotable_1.default)(docPdf, {
        head: [
            [
                "Núm. Periodo",
                "Saldo Insoluto Auto",
                "Prima Seguro Daños con IVA",
                "Prima Seguro Vida con IVA",
                "Pago Mensual Capital Auto",
                "Pago Mensual Intereses Auto",
                "IVA Intereses Auto",
                "Pago Total con IVA",
            ],
        ],
        startY: 200,
        body: tableRows,
    });
    return docPdf;
}
exports.generate = generate;
